import type { SVGProps } from "react";

export function IconPurpleTicTacToe(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#FBF6FE" />
      <circle
        cx="35.5"
        cy="20.5"
        r="5.5"
        fill="#2E2E2E"
        stroke="#2E2E2E"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M15.5 15.5L25.5 25.5M15.5 25.5L25.5 15.5M30.5 30.5L40.5 40.5M30.5 40.5L40.5 30.5"
        stroke="#2A222A"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <circle
        cx="20.5"
        cy="35.5"
        r="5.5"
        fill="#2E2E2E"
        stroke="#2E2E2E"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
